import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/hroffice.webp';
import screenshot_target from '../../../images/letterfunnel/thieryketz.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Thiery Ketz"
      firstname="Thiery"
      companyname="HROffice"
      competition="Recruitee en Carerix"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/thieryketz.js